export const modals = {
  "shiftModal": {
    "titleClose": "ปิดกะ",
    "titleOpen": "เปิดกะ (เข้างาน)",
    "cashier": "แคชเชียร์",
    "loading": "กำลังโหลดสถานะกะ...",
    "infoTitle": "ข้อมูลกะปัจจุบัน:",
    "startingCash": "เงินทอนเริ่มต้น",
    "expectedCash": "เงินสดที่คาดหวัง (เบื้องต้น)",
    "actualCash": "เงินสดที่นับได้จริง",
    "actualCashPlaceholder": "ยอดเงินที่นับได้",
    "startingCashPlaceholder": "เงินทอนในลิ้นชัก",
    "confirmClose": "ยืนยันการปิดกะ",
    "confirmOpen": "ยืนยันการเปิดกะ"
  },
  "discountModal": {
    "title": "ใช้ส่วนลด",
    "subtotal": "ยอดรวม:",
    "percentage": "เปอร์เซ็นต์",
    "amount": "จำนวนเงิน",
    "remove": "ลบส่วนลด",
    "apply": "ใช้ส่วนลด"
  },
  "paymentSuccess": {
    "title": "ชำระเงินสำเร็จ!",
    "orderNumber": "คำสั่งซื้อ #",
    "print": "พิมพ์ใบเสร็จ",
    "newSale": "การขายใหม่"
  },
  "inventoryAdjust": {
    "title": "ปรับสต็อก",
    "currentStock": "สต็อกปัจจุบัน:",
    "changeAmount": "จำนวนที่เปลี่ยนแปลง",
    "changeAmountHint": "ค่าบวกเพื่อเพิ่มสต็อก, ค่าลบเพื่อนำออก",
    "reason": "เหตุผลในการปรับ",
    "saving": "กำลังบันทึก...",
    "save": "บันทึกการปรับปรุง",
    "reasonRestock": "รับสินค้า (เติมสต็อก)",
    "reasonCorrection": "แก้ไข / นับใหม่",
    "reasonDamage": "สินค้าเสียหาย",
    "reasonTheft": "สูญหาย / ถูกขโมย"
  },
  "inventoryHistory": {
    "title": "ประวัติคลังสินค้า",
    "sku": "SKU:",
    "loading": "กำลังโหลดประวัติ...",
    "table": {
      "date": "วันที่",
      "change": "การเปลี่ยนแปลง",
      "newQty": "จำนวนใหม่",
      "reason": "เหตุผล",
      "user": "ผู้ใช้"
    },
    "empty": "ไม่พบประวัติสำหรับสินค้านี้",
    "close": "ปิด"
  },
  "inviteEmployee": {
    "title": "เชิญพนักงานใหม่",
    "successTitle": "สร้างลิงก์คำเชิญแล้ว!",
    "successMessage": "คัดลอกลิงก์นี้และส่งให้พนักงานใหม่",
    "copy": "คัดลอกลิงก์",
    "copied": "คัดลอกแล้ว!",
    "close": "ปิด",
    "emailLabel": "อีเมลพนักงาน",
    "roleLabel": "ตำแหน่ง",
    "generateButton": "สร้างลิงก์คำเชิญ"
  },
  "productForm": {
    "titleEdit": "แก้ไขสินค้า",
    "titleAdd": "เพิ่มสินค้าใหม่",
    "name": "ชื่อสินค้า",
    "sku": "SKU (รหัสสินค้า)",
    "skuPlaceholder": "เช่น TE-100-A1",
    "category": "หมวดหมู่",
    "lotNumber": "หมายเลขล็อต",
    "lotNumberPlaceholder": "สำหรับติดตามแบทช์กัญชา",
    "price": "ราคา",
    "cost": "ต้นทุน",
    "stock": "จำนวนในสต็อก",
    "lowStockThreshold": "เกณฑ์สต็อกต่ำ",
    "status": "สถานะ",
    "isTaxable": "สินค้านี้ต้องเสียภาษี",
    "statusLabel": "สินค้าเปิดใช้งานและพร้อมจำหน่าย",
    "cancel": "ยกเลิก",
    "save": "บันทึกสินค้า"
  },
  "customerForm": {
    "titleEdit": "แก้ไขข้อมูลลูกค้า",
    "titleAdd": "เพิ่มลูกค้าใหม่",
    "name": "ชื่อ-นามสกุล",
    "nationalId": "บัตรประชาชน / พาสปอร์ต",
    "dob": "วันเกิด",
    "dobError": "ลูกค้าต้องมีอายุ 20 ปีขึ้นไป",
    "phone": "เบอร์โทรศัพท์",
    "cardUid": "รหัสบัตร (NFC/RFID)",
    "cardUidPlaceholder": "สแกนบัตร หรือกรอกรหัสด้วยตนเอง",
    "cancel": "ยกเลิก",
    "save": "บันทึกข้อมูลลูกค้า"
  },
   "userForm": {
    "titleEdit": "แก้ไขข้อมูลพนักงาน",
    "name": "ชื่อ-นามสกุล",
    "email": "อีเมล (ไม่สามารถเปลี่ยนได้)",
    "role": "ตำแหน่ง",
    "status": "สถานะ",
    "pin": "รหัส PIN 6 หลัก",
    "pinPlaceholder": "เว้นว่างไว้หากไม่ใช่แคชเชียร์",
    "save": "บันทึกข้อมูลพนักงาน"
  },
  "posDeviceForm": {
    "titleEdit": "แก้ไขอุปกรณ์ POS",
    "titleAdd": "เพิ่มอุปกรณ์ POS ใหม่",
    "name": "ชื่ออุปกรณ์",
    "namePlaceholder": "เช่น เคาน์เตอร์หลัก",
    "store": "ร้านค้า",
    "status": "สถานะ",
    "statusActive": "เปิดใช้งาน",
    "statusInactive": "ไม่ใช้งาน"
  },
  "rewardForm": {
      "titleEdit": "แก้ไขของรางวัล",
      "titleAdd": "เพิ่มของรางวัลใหม่",
      "name": "ชื่อของรางวัล",
      "sku": "SKU (ต้องตรงกับ SKU สินค้าเพื่อใช้แลก)",
      "skuPlaceholder": "เช่น REWARD-T-SHIRT",
      "points": "แต้มที่ใช้แลก",
      "cost": "ต้นทุน (สำหรับบัญชี)",
      "tag": "แท็ก",
      "tagPlaceholder": "เช่น ใหม่, ยอดนิยม, จำกัด",
      "limit": "จำกัดการแลกต่อเดือน/ลูกค้า",
      "limitPlaceholder": "เว้นว่างไว้ถ้าไม่จำกัด",
      "imageUrl": "URL รูปภาพ",
      "imageUrlPlaceholder": "https://...",
      "description": "รายละเอียด",
      "statusLabel": "ของรางวัลเปิดใช้งานและแลกได้"
  },
  "tierForm": {
      "titleEdit": "แก้ไขระดับสมาชิก",
      "titleAdd": "เพิ่มระดับสมาชิกใหม่",
      "name": "ชื่อระดับ",
      "icon": "ไอคอน (Emoji)",
      "minPoints": "แต้มขั้นต่ำเพื่อไปถึงระดับนี้",
      "benefits": "สิทธิประโยชน์",
      "benefitsPlaceholder": "เช่น ส่วนลด 10%, เครื่องดื่มฟรี"
  },
  "quantityModal": {
    "title": "แก้ไขจำนวน",
    "product": "สินค้า",
    "labelWeight": "น้ำหนัก (กรัม)",
    "labelQuantity": "จำนวน",
    "cancelButton": "ยกเลิก",
    "updateButton": "อัปเดต"
  },
  "smartPrescriptionModal": {
    "title": "ออกใบรับรองแพทย์",
    "subtitle": "ระบบออกใบรับรองแพทย์ดิจิทัล",
    "requestId": "รหัสคำขอ",
    "patientInfo": "ข้อมูลผู้ป่วย",
    "patientName": "ชื่อ-สกุล",
    "patientAge": "อายุ",
    "patientAgeUnit": "ปี",
    "patientId": "เลขประจำตัว",
    "symptomsReported": "อาการที่ระบุ",
    "medicalDecision": "การวินิจฉัยและการรักษา",
    "aiAssistant": "ผู้ช่วย AI",
    "aiDescription": "อธิบายใบสั่งยาเป็นภาษาพูด แล้ว AI จะช่วยกรอกข้อมูลลงในฟอร์ม",
    "aiPlaceholder": "ตัวอย่าง: Tiger Eye 3g/วัน เป็นเวลา 30 วัน สำหรับอาการนอนไม่หลับและความเครียด ใช้ก่อนนอน",
    "aiGenerateButton": "สร้างรายละเอียด",
    "aiGeneratingButton": "กำลังสร้าง...",
    "aiDisabled": "ผู้ช่วย AI ถูกปิดใช้งาน โปรดตั้งค่า Gemini API key ของคุณ",
    "prescriptionDetails": "รายละเอียดใบสั่งยา",
    "productLabel": "ผลิตภัณฑ์",
    "productSelect": "เลือกผลิตภัณฑ์",
    "symptomsLabel": "อาการ",
    "dosageLabel": "ปริมาณ/วัน",
    "unitLabel": "หน่วย",
    "unitGram": "กรัม",
    "unitPiece": "ชิ้น",
    "durationLabel": "ระยะเวลา (วัน)",
    "totalLabel": "รวม",
    "usageInstructionsLabel": "คำแนะนำการใช้งาน (Diagnosis / Usage)",
    "rejectButton": "ปฏิเสธเคส",
    "approveButton": "อนุมัติและเซ็นชื่อ",
    "signedBy": "ลงนามดิจิทัลโดย",
    "templateInsomnia": "ชุดนอนไม่หลับ",
    "templatePain": "ชุดแก้ปวด",
    "templateAnxiety": "ชุดคลายเครียด"
  },
  "videoCall": {
    "connecting": "กำลังเชื่อมต่อ...",
    "waiting": "กำลังรออีกฝ่าย...",
    "capture": "ถ่ายภาพและบันทึกหลักฐาน",
    "failed": "การเชื่อมต่อล้มเหลว",
    "close": "ปิด"
  },
  "accountForm": {
    "titleEdit": "แก้ไขบัญชี",
    "titleAdd": "เพิ่มบัญชีใหม่",
    "name": "ชื่อบัญชี",
    "type": "ประเภท",
    "description": "คำอธิบาย"
  }
};
